import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

interface PaypalHandlerProps {
  amount: number;
  paypalClientId: string;
  reference: string;
}
export default function PaypalHandler(props: PaypalHandlerProps) {
  const onCreateOrder = (data: any, actions: any) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: props.amount + "",
          },
        },
      ],
    });
  };

  const onApproveOrder = (data: any, actions: any) => {
    return actions.order.capture().then((details: any) => {
      const name = details.payer.name.given_name;
      console.log(details);
      window.location.href = `${window.location.origin}/p/${props?.reference}/status?method=paypal`;
      alert(`Transaction completed by ${name}`);
    });
  };
  return (
    <PayPalScriptProvider
      options={{
        clientId:
          "AVNAMfIniOj8Vm_JiD3rC9bJ7JI9HVImvGaf2-huJc0Ax9gcfC94yGzHSC_jYJFyjLcpVRFvlmkUqAPT",
      }}
    >
      <PayPalButtons
        style={{ layout: "vertical" }}
        createOrder={onCreateOrder}
        onApprove={onApproveOrder}
      />
    </PayPalScriptProvider>
  );
}
